import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Table } from '../../../common/table'
import { TABLE_COL } from '../constant'
import { selectProfileById, selectProfileIds } from '../store/slice'
import { CheckboxAll } from './CheckboxAll'
import { CheckboxCell } from './CheckboxCell'
import { DeleteCell } from './DeleteCell'
import { EditCell } from './EditCell'
import { EnableEmailCell } from './EnableEmailCell'
import { PortfolioCell } from './PortfolioCell'
import { ProfileNameCell } from './ProfileNameCell'
import { ToolBar } from './ToolBar'

export const ProfileTable = () => {
  const ids = useSelector(selectProfileIds)

  const getSchema = () => {
    return Object.keys(TABLE_COL).map((key) => {
      const title = `alertSetting.${key}`
      const colId = TABLE_COL[key]
      const thStyle = {
        justifyContent: [TABLE_COL.ENABLE_EMAIL].includes(colId)
          ? 'center'
          : '',
      }
      const tdStyle = {
        width:
          colId === TABLE_COL.CHECKBOX
            ? 40
            : colId === TABLE_COL.PROFILE_NAME
            ? '60%'
            : '',
        position: 'relative',
      }

      return {
        colId,
        title,
        isI18n: true,
        thStyle,
        tdStyle,
        renderTh: (title) => {
          switch (colId) {
            case TABLE_COL.CHECKBOX:
              return <CheckboxAll />
            case TABLE_COL.TOOLS:
              return ''
            default:
              return title
          }
        },
        render: (data, { rowId }) => {
          switch (colId) {
            case TABLE_COL.CHECKBOX:
              return <CheckboxCell rowId={rowId} />
            case TABLE_COL.PROFILE_NAME:
              return <ProfileNameCell rowId={rowId} name={data} />
            case TABLE_COL.PORTFOLIO:
              return <PortfolioCell rowId={rowId} data={data} />
            case TABLE_COL.ENABLE_EMAIL:
              return <EnableEmailCell rowId={rowId} checked={data} />
            case TABLE_COL.TOOLS:
              return (
                <Element className="dFlex alignItemsCenter gap1">
                  <EditCell rowId={rowId} />
                  <DeleteCell rowId={rowId} />
                </Element>
              )
            default:
              return data
          }
        },
      }
    })
  }

  return (
    <>
      <ToolBar />
      <Table
        ids={ids}
        getDataFromRedux={selectProfileById}
        schema={getSchema()}
        autoHeightMax={200}
      />
    </>
  )
}
